<template>
  <v-container>
    <div v-if="!loading">
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.orderId"
                outlined
                label="Order ID"
                dense
                readonly
              />
            </v-flex>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.poNum"
                outlined
                label="PO #"
                dense
                readonly
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.company.name"
                outlined
                label="Customer"
                dense
                readonly
              />
            </v-flex>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="addressFormatter(order.shipTo)"
                outlined
                label="Shipping Address"
                dense
                readonly
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.orderDate"
                outlined
                label="Order Date"
                dense
                readonly
              />
            </v-flex>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="addressFormatter(order.billTo)"
                outlined
                label="Billing Address"
                dense
                readonly
              />
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.formattedOrderTotal"
                outlined
                label="Order Total"
                dense
                readonly
              />
            </v-flex>
            <v-flex sm12 md4 pl-2 pr-2>
              <v-text-field
                :value="order.specialInstructions"
                outlined
                label="Special instructions"
                dense
                readonly
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs12>
              <timeline title="Order Status" :timeline="order.timeline" />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>

      <v-layout>
        <v-flex>
          <v-alert icon="shopping_cart" color="primary" text>
            <v-flex style="float: left">Order Items</v-flex>
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-data-table
            :headers="orderItemHeaders"
            :items="order.items"
            :dense="true"
            hide-default-footer
          >
            <template v-slot:item.orderStatus="{ item }">
              <v-text-field
                v-model="item.itemStatus"
                label="Order Status"
                outlined
                dense
                class="mt-6"
              ></v-text-field>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>

    <v-layout v-else align-center justify-center>
      <v-progress-circular
        indeterminate
        color="primary"
        size="100"
      ></v-progress-circular>
    </v-layout>
  </v-container>
</template>

<script>
import request from "@/modules/request";
import moment from "moment";
import { assign } from "lodash";
import Timeline from "@/components/shared/Timeline";

export default {
  name: "Order",
  async mounted() {
    await this.loadData();
  },
  components: {
    Timeline,
  },
  data() {
    return {
      updateStatusModal: false,
      updateStatusTitle: "",
      updateStatusType: null,
      updateStatusInstructions: "",
      datepicker: true,
      order: null,
      distributors: [],
      loading: true,
      orderStatuses: ["Submitted", "Confirmed", "Completed"],
      updatedStatus: null,
      orderItemHeaders: [
        {
          text: "Product Code",
          value: "productCode",
        },
        {
          text: "Category",
          value: "category.name",
        },
        {
          text: "Description",
          value: "description[0].value",
        },
        {
          text: "Quantity",
          value: "quantity",
        },
        {
          text: "Price",
          value: "formattedPrice",
        },
        // {
        //   text: "Status",
        //   value: "orderStatus"
        // }
      ],
    };
  },
  methods: {
    addressFormatter(address) {
      const { name, address1, address2, city, state, zip } = address;

      if (address2) {
        return `${name} - ${address1}, ${address2}, ${city}, ${state} ${zip}`;
      } else {
        return `${name} - ${address1}, ${city}, ${state} ${zip}`;
      }
    },
    async loadData() {
      const { getOrder } = this;
      const [order] = await Promise.all([getOrder()])
        .then((results) => {
          this.loading = false;
          return results;
        })
        .catch((error) => {
          console.error(error);
        });

      this.formatOrder(order);
    },
    formatOrder(order) {
      const formattedOrder = assign(order, {
        orderDate: moment(order.createdAt).format("MM-DD-YYYY"),
      });
      this.order = formattedOrder;
    },
    async getOrder() {
      const { id } = this.$route.params;
      return request
        .callInternal({
          method: "get",
          route: `/api/order/${id}`,
        })
        .then((results) => {
          return results.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
